import { useCallback, useRef } from "react";

/**
 * Anropar `onLongPress` när användaren håller kvar fingret/musknappen.
 *
 * Panelen visar ingen adminknapp — adminläget nås genom att hålla in klockan,
 * så att personalen inte råkar hamna där.
 */
export function useLongPress(onLongPress: () => void, delay = 3000) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clear = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
  }, []);

  const start = useCallback(() => {
    clear();
    timer.current = setTimeout(() => {
      timer.current = null;
      onLongPress();
    }, delay);
  }, [clear, delay, onLongPress]);

  return {
    onPointerDown: start,
    onPointerUp: clear,
    onPointerLeave: clear,
    onPointerCancel: clear,
    // Windows-pekskärmar öppnar annars en högerklicksmeny mitt i gesten.
    onContextMenu: (event: { preventDefault: () => void }) => event.preventDefault(),
  };
}
